import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store/store.ts';
import { Constants } from '../Constants.ts';
import { getSolutionSliderItems } from '../Util/solutionComponentsToSliderItems.ts';

export const MatchingProductsSelector = (state: RootState) => state.MatchingProducts.matchingProducts;
export const SolutionComponentsSelector = (state: RootState) => state.MatchingProducts.solutionComponents;
export const SolutionPriceContainerSelector = (state: RootState) => state.MatchingProducts.solutionPriceContainer;
export const AddToCartButtonSelector = (state: RootState) => state.MatchingProducts.addToCartButton;
export const ProductPageMatchSelector = (state: RootState) => state.MatchingProducts.productPageMatch;
export const SelectedSolutionIndexSelector = (state: RootState) => state.MatchingProducts.selectedSolutionIndex;

export const SolutionSliderItemsSelector = createSelector(
  [SolutionComponentsSelector, MatchingProductsSelector, SelectedSolutionIndexSelector],
  (solutionComponents, matchingProducts, selectedSolutionIndex) =>
    getSolutionSliderItems(solutionComponents, matchingProducts, selectedSolutionIndex)
);

export const FitTipsSelector = createSelector(
  (state) => state,
  (state: RootState) => {
    return (
      state.MatchingProducts.matchingProducts
        ?.find((x) => x.FitTips?.length > 0)
        ?.FitTips.filter((x) => x.FitTipClassification === Constants.FitTipClassifications.VEHICLE_SPECIFIC) ?? []
    );
  }
);
